import {useEffect, useState} from 'react';

export function useIsMobile() {
  const query = window.matchMedia('screen and (max-width: 600px)');
  const [isMobile, setIsMobile] = useState(query.matches);
  useEffect(() => {
    const handler = (ev: MediaQueryListEvent) => setIsMobile(ev.matches);
    if ('addEventListener' in handler) {
      query.addEventListener('change', handler);
    } else {
      query.addListener(handler);
    }

    return () => {
      if ('removeEventListener' in handler) {
        query.removeEventListener('change', handler);
      } else {
        query.removeListener(handler);
      }
    };
  }, []);
  return isMobile;
}
